export function groupBy(array, key) {
  return Object.values(array).reduce((result, currentValue) => {
    (result[currentValue[key]] = result[currentValue[key]] || []).push({
      ...currentValue,
    });
    return result;
  }, {})
}